import type { ActionType, SalesStatus } from '@shared/types/sales-action';

export const NEXT_ACTION_BY_STATUS: Record<SalesStatus, ActionType[]> = {
  no_contact: ['call', 'direct_message', 'referral_request'],
  contacted: ['call', 'email', 'referral_request'],
  in_dialogue: ['call', 'email', 'referral_request'],
  appointment: ['material_prep', 'pre_hearing'],
  negotiation_c: ['concern_response', 'quote_pricing', 'next_appointment'],
  negotiation_b: ['concern_response', 'quote_pricing', 'next_appointment'],
  negotiation_a: ['final_adjustment', 'contract_procedure'],
  won: [],
  lost: [],
};

export function isNextActionAllowedForStatus(
  status: SalesStatus,
  actionType: ActionType | null | undefined,
): boolean {
  return actionType != null && NEXT_ACTION_BY_STATUS[status].includes(actionType);
}
